@import "../config/_helpers";
.review {
	position: relative;
	background: #def8f4;
	padding: 10px;
	user-select: none;
	height: 100%;
	display: flex;
	flex-direction: column;
	.review-text {
		margin-top: 10px;
		margin-bottom: 10px;
		flex: 1;
		display: -webkit-box;
		@include limitLines(5);
    }
    .view-review{
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .review-rating{
        padding: 5px 10px;
        border-radius: 10px;
        color: var(--contrast-color-dark-2);
        background: var(--contrast-color-light-6);
        span{
            font-size: 9px;
        }
    }
    .bottom{
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        .reviewer{
            font-weight: bold;
            margin-top: 10px;
            opacity: .2;
            display: block;
        }
        .timeago{
            font-size: 9px;
            opacity: .5;
            margin-top: 10px;
        }
    }
}
